import React from "react";
import { t } from "i18next";

const Profile = () => {
  return (
    <div className="col col-10 my-12">
      <div style={{ height: "100%" }}>
        <div className="v-card v-sheet theme--light desktop_profile_card ml-4">
          <div className="v-card__title">
            <label className="--v-primary-base text-left text-capitalize mx-6 profile-txt">
              {t("MyProfile")}
            </label>
            <button
              type="button"
              className="icon-btn v-btn v-btn--icon v-btn--round theme--light v-size--default"
            >
              <span className="v-btn__content">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={21}
                  height="20.944"
                  className
                >
                  <defs />
                  <path
                    d="M20.993 3.183c-.046.178-.079.356-.132.534a3.081 3.081 0 01-.784 1.252q-4.843 4.843-9.693 9.686a1.419 1.419 0 01-.507.323c-1.417.488-2.84.949-4.263 1.43a.83.83 0 01-.784-.066.779.779 0 01-.25-.936c.369-1.107.778-2.2 1.094-3.321a4.9 4.9 0 011.371-2.214c2.965-2.919 5.9-5.864 8.83-8.81a3.21 3.21 0 011.9-1.041c.013 0 .02-.013.033-.02h.659a.26.26 0 00.092.033 2.82 2.82 0 012.306 1.957 5.537 5.537 0 01.138.547c-.01.211-.01.428-.01.646z"
                    className="a"
                  />
                  <path
                    d="M.013 11.215V3.776a2.233 2.233 0 011.845-2.254 2.635 2.635 0 01.507-.04h8.751c.514 0 .83.244.87.672a.729.729 0 01-.7.817c-.079.007-.165 0-.244 0H2.418a1.33 1.33 0 00-.362.04.71.71 0 00-.534.626 3.332 3.332 0 00-.013.264v14.628a2.04 2.04 0 00.013.283.721.721 0 00.633.626 1.767 1.767 0 00.264.013H15.57c.072 0 .152 0 .224-.007a.721.721 0 00.685-.712c.013-.283.007-.573.007-.863v-6.5a1.511 1.511 0 01.053-.422.738.738 0 011.41.053 1.187 1.187 0 01.033.3c0 2.438.007 4.876 0 7.314a2.246 2.246 0 01-1.746 2.26 2.333 2.333 0 01-.567.059H2.313A2.24 2.24 0 010 18.628c.013-2.451.013-4.935.013-7.413z"
                    className="a"
                  />
                </svg>
              </span>
            </button>
          </div>
          <div className="profile-detail-card v-card v-sheet theme--light elevation-0">
            <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
              <div className="col-md-3 col-lg-2 col">
                <label className="field-name">{t("Email")}</label>
              </div>
              <div className="col-md-9 col-lg-10 col">
                <label />
              </div>
              <div className="col col-12">
                <hr
                  role="separator"
                  aria-orientation="horizontal"
                  className="v-divider theme--light"
                />
              </div>
            </div>
            <div className="row hidden-sm-and-down pb-5 no-gutters align-end">
              <div className="pb-2 col-md-10 col">
                <label className="field-name-desktop">{t("Username")}</label>
              </div>
              <div className="pa-2 col-md-5 col filled-label">
                <label>demo21</label>
              </div>
            </div>
            <div className="row hidden-sm-and-down pb-2 no-gutters align-end">
              <div className="pb-2 col-md-10 col">
                <label className="field-name-desktop'">
                  {t("DateOfBirth")}
                </label>
              </div>
              <div className="pa-2 col-md-5 col empty-label">
                <label />
              </div>
            </div>
            <div className="row hidden-sm-and-down pb-2 no-gutters align-end">
              <div className="pb-2 col-md-10 col">
                <label className="field-name-desktop">{t("Fullname")}</label>
              </div>
              <div className="pa-2 col-md-5 col empty-label">
                <label />
              </div>
            </div>
            <div className="row hidden-sm-and-down mb-4 no-gutters align-end">
              <div className="pb-2 col-md-10 col">
                <label className="field-name-desktop">{t("Currency")}</label>
              </div>
              <div className="pa-2 col-md-5 col filled-label">
                <label>BDT</label>
              </div>
            </div>
          </div>
        </div>
        {/**/}
        {/**/}
        <div data-v-c5353408 role="dialog" className="v-dialog__container">
          {/**/}
        </div>
        <div data-v-c5353408 role="dialog" className="v-dialog__container">
          {/**/}
        </div>
        <div data-v-c5353408 role="dialog" className="v-dialog__container">
          {/**/}
        </div>
      </div>
    </div>
  );
};

export default Profile;
